import { BasePlugin, Plugin, Events, Errors, Sniffer, Util, STATE_CLASS, I18N } from './player';
import Player from './index-umd';

export { Player as default, BasePlugin, Plugin, Events, Errors, Sniffer, Util, STATE_CLASS, I18N };